import React from 'react';

import Card from '@material-ui/core/Card';

import ActionsContent from './ActionsContent';

// const styleOverlay = {
//     display: "flex",
//     justifyContent: "flex-end",
//     alignItems: "center",
//     left: 0,
//     right: 0,
//     zIndex: theme.zIndex.overlay + 1,
//     height: "75px",
//     position: "fixed",
//     paddingRight: theme.spacing.unit*4,
// }
//
// const styleNoOverlay = {
//     display: "flex",
//     justifyContent: "flex-end",
//     alignItems: "center",
//     left: 0,
//     right: 0,
//     zIndex: theme.zIndex.overlay + 1,
//     height: "75px",
//     position: "fixed",
//     paddingRight: theme.spacing.unit*4,
// }

//WARNING: do not wrapp withStyles HOC as displayName will not be preserved
const Actions = ({ help, theme, actions }) => {
  const showOverlay = help && (help.showHelp || help.currentMission.inProgress);

  return(
    <div>
      <Card style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        left: 0,
        right: 0,
        zIndex: theme.zIndex.actionsBar,
        height: "75px",
        position: "fixed",
        paddingRight: theme.spacing.unit*4,
      }}>
        {showOverlay &&
          <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            position: 'absolute',
            zIndex: theme.zIndex.actionsBar
          }}/>
        }
        <ActionsContent actions={actions} help={help}/>
      </Card>
      <div style={{ height: "80px" }} />
    </div>

  );
};

Actions.displayName = "Actions";

export default Actions;



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/Actions.jsx